module.exports = __webpack_public_path__ + "static/media/google-btn.9debdcc2.webp";